import { Component, Input } from '@angular/core'
import { CommonModule } from '@angular/common'
import { GalleryItemComponent } from '../gallery-item/gallery-item.component'
import { Router } from '@angular/router'
import { ButtonComponent } from '../button/button.component'
import { CosentinoSvgComponent } from '@components/cosentino-svg/cosentino-svg.component'
import { TranslateModule } from '@ngx-translate/core'
import { Gallery } from '../../interfaces/api/Gallery'

@Component({
  selector: 'app-gallery-grid',
  standalone: true,
  imports: [CommonModule, GalleryItemComponent, ButtonComponent, CosentinoSvgComponent, TranslateModule],
  templateUrl: './gallery-grid.component.html',
  styleUrl: './gallery-grid.component.scss'
})
export class GalleryGridComponent {
  @Input() galleries: Gallery[] = [];

  constructor(private router: Router) {}

  formatStatusForGTM(status: string | null | undefined): string {
    if (!status) return 'unknown';
    return status.toLowerCase().replace(/_/g, '-') + '_button_view-gallery';
  }

  goToNew(): void {
    this.router.navigate(['/my-gallery']);
  }

  goToEdit(gallery: Gallery): void {
    this.router.navigate(['/my-gallery'], {
          queryParams: {
              id: gallery.id,
          }
      });
  }
}
